/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type ApprovalPaginatedProperty =
  typeof ApprovalPaginatedProperty[keyof typeof ApprovalPaginatedProperty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApprovalPaginatedProperty = {
  CREATED_AT: 'CREATED_AT',
  DUE_DATE: 'DUE_DATE',
} as const;
